module.exports = "<div class=\"y-textarea-ctn y-relative\">\n  <textarea autocomplete=\"off\" wrap=\"soft\" class=\"y-textarea\" data-bind=\"\n  css:{'y-textarea-changed': enableChangingStyle && textChanged()},\n  attr:{tabindex: tabindex,maxlength:maxlength,rows:rows,placeholder:placeholder,disabled:disabled, fieldid: fieldid},style:{resize:resizeType},value:value,\n    event:{input:onInput,keyup:onKeyup,click:onClick, blur:onBlur}\"></textarea>\n  <!-- ko if: showCount && !disabled() -->\n  <div class=\"y-textarea-msg\" data-bind=\"html: countMsg\"></div>\n  <!-- /ko -->\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/textarea/index.html
// module id = 514
// module chunks = 0